import React, { Component, Fragment } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import { Grid, Hidden } from "@material-ui/core";

import styles from "./styles.scss";
import { color } from "@material-ui/core/colors";
import { shouldUpdate } from "../../../../utils";

let count = 0;
const idPrefix = "weeklyFailureHeatMap";

@CSSModules(styles, { allowMultiple: true })
class WeeklyFailureHeatMap extends Component {
	constructor(props) {
		super(props);
		this.props.initComponent(this.props.id, this.props.component);
	}
	render() {
		if (!this.props.componentData || !this.props.componentData.weeklyFailures) {
			return null;
		}
		//attempting to implement responsiveness all in the same grid results in rounding errors which leaves
		//1px white lines ranomdly in the heatmap.
		//To solve, separate layouts are used for each screen size needed
		let fragmentCount = this.props.componentData.weeklyFailures.length;
		let xsSize = 3;
		let smSize = 4;
		return (
			<div styleName="component-wrapper">
				<div styleName="component-title">
					{this.props.component.chartTitle ||
						"Distribution when entire Time Offset outside range in relation to time of day for reporting period."}
				</div>
				{this.getHeatMapFragments(this.props.componentData.weeklyFailures)}
				{/*
					<div styleName="wraps">
						{this.props.componentData.weeklyFailures.map((weeklyFailure, index) =>
							this.getHeatMapFragment(weeklyFailure, index)
						)}
					</div> 
				*/}
			</div>
		);
	}

	getHeatMapFragments(weeklyFailures) {
		var w = window.innerWidth;
		if (this.props.isMenuOpen) {
			w = w - 200;
		}
		var numOfItems = 0;

		var xs = 600;
		var sm = 960;
		var md = 1280;

		if (w <= xs) {
			numOfItems = 5;
		} else if (w <= sm) {
			numOfItems = 6;
		} else if (w <= md) {
			numOfItems = 14;
		} else if (w > md) {
			numOfItems = 28;
		}

		if (weeklyFailures.length < numOfItems) {
			// do a single row;
			return (
				<div styleName="fragment-container">
					{weeklyFailures.map((weeklyFailure, index) => this.getHeatMapFragment(weeklyFailure, index))}
				</div>
			);
		} else {
			if (weeklyFailures.length > 2 * numOfItems) {
				// do multiple rows
				let overall = 0;
				let count = 0;
				let fragments = [];
				fragments.push([]);
				let keyCount = 0;
				for (var ii = 0; ii < weeklyFailures.length; ii++) {
					if (count >= numOfItems) {
						count = 0;
						overall++;
						fragments.push([]);
					}
					fragments[overall].push(this.getHeatMapFragment(weeklyFailures[ii], ii));
					count++;
					keyCount++;
				}
				for (; count < numOfItems; count++) {
					fragments[overall].push(<div key={keyCount} styleName="fragment-filler"></div>);
					keyCount++;
				}

				return (
					<Fragment>
						{fragments.map((fragmentContainer, index) => (
							<div key={index} styleName="fragment-container">
								{fragmentContainer.map(fragment => fragment)}
							</div>
						))}
					</Fragment>
				);
			} else {
				// figure out how many for 2 rows.
				let overall2 = 0;
				let firstRow = Math.ceil(weeklyFailures.length / 2);
				let count2 = 0;
				let fragments2 = [];
				fragments2.push([]);
				for (var jj = 0; jj < weeklyFailures.length; jj++) {
					if (count2 >= firstRow) {
						count2 = 0;
						overall2 = 1;
						fragments2.push([]);
					}
					fragments2[overall2].push(this.getHeatMapFragment(weeklyFailures[jj], jj));
					count2++;
				}
				if (Math.floor(weeklyFailures.length / 2) !== firstRow) {
					fragments2[overall2].push(<div key={weeklyFailures.length} styleName="fragment-filler"></div>);
				}

				return (
					<Fragment>
						{fragments2.map((fragmentContainer, index) => (
							<div key={index} styleName="fragment-container">
								{fragmentContainer.map(fragment => fragment)}
							</div>
						))}
					</Fragment>
				);
			}
		}
	}

	setup() {
		this.props.loadData(this.props.id, this.props.component, this.props.timePeriod, this.props.onLoadComplete);
	}

	resize = () => this.forceUpdate();

	componentDidMount() {
		this.setup();
		window.addEventListener("resize", this.resize);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.resize);
	}

	getIndexMap(fragmentSize, totalFragments) {
		//maximum fragments per row based on teh 12 column grid layout
		let maxPerRow = Math.floor(12 / fragmentSize);
		//total rows we need to hold totalfragments, based on max per row
		let totalRows = Math.ceil(totalFragments / maxPerRow);
		//for maximum even-ness per row then each row must have at least (maxPerRow - 1) fragments in it.
		//So each row will have either (maxPerRow) or (maxPerRow - 1) fragments in it
		//extra fragments is the amount of rows that will have the full maxPerRow
		let extraFragments = totalFragments - totalRows * (maxPerRow - 1);

		//now build an array of objects where each each element in the array contains the start and and index for which fragments to display for that row
		let indexMap = [];
		let extrasAdded = 0;
		for (var ii = 0; ii < totalRows; ii++) {
			let startIndex = (maxPerRow - 1) * ii + extrasAdded;
			let endIndex = startIndex + maxPerRow - 1;
			if (extrasAdded < extraFragments) {
				endIndex++;
				extrasAdded++;
			}
			indexMap.push({
				startIndex: startIndex,
				endIndex: endIndex
			});
		}
		return indexMap;
	}

	getHeatMapFragment(weeklyFailure, index) {
		return (
			<div key={index} styleName="heatmap-fragment">
				<div styleName="heatmap-text">{weeklyFailure.display}</div>
				<div style={{ backgroundColor: weeklyFailure.color }} styleName="heatmap-color tooltip">
					<span styleName="tooltiptext">Fail Count: {weeklyFailure.failures}</span>
				</div>
			</div>
		);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.componentData != this.props.componentData) {
			return true;
		} else if (prevProps.component != this.props.component || prevProps.timePeriod != this.props.timePeriod) {
			this.setup();
			return false;
		} else {
			return false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (id, component, timePeriod, onLoadComplete) =>
			dispatch(actions.loadData(id, component, timePeriod, onLoadComplete)),
		initComponent: (id, component) => dispatch(actions.initComponent(id, component))
	};
};

const mapStateToProps = (state, ownProps) => ({
	componentData: state.weeklyfailureheatmap.instances[ownProps.id],
	isMenuOpen: state.menu.isOpen
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
		this.id = idPrefix + count;
		count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(
				mapStateToProps,
				bindAction
			)(WeeklyFailureHeatMap)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/HeatMaps/DailyFailureHeatMap/DailyFailureHeatMap.js